export enum FormType {
    PART_NUMBER = 'PART_NUMBER_FORM',
    EQUIPMENT = 'EQUIPMENT_FORM',
    LIFECYCLE = 'LIFECYCLE_FORM',
    DESCRIPTION = 'DESCRIPTION_FORM',
    SPECIAL_IDENTIFIERS = 'SPECIAL_IDENTIFIERS_FORM'
}
